import React, {useEffect, useState} from 'react';
import i18n from 'i18next';
import Button from '@/Components/Button';
import Authenticated from '@/Layouts/Authenticated';
import {Head, Link, useForm, usePage} from '@inertiajs/inertia-react';
import "../../../sass/guest/add-attendance.scss";
import smallAttendanceIcon from "../../../icons/attendance-small.svg"
import mediumAttendanceIcon from "../../../icons/attendance-medium.svg"
import largeAttendanceIcon from "../../../icons/attendance-large.svg"


export default function AddAttendance() {

    const [attendanceOptions, setAttendanceOptions] = useState([]);

    useEffect(() => {
        axios.get(route('organization.add-attendance.fetch'))
            .then(res => {setAttendanceOptions(res.data)});
    }, [])

    const {data, setData, post, processing, errors} = useForm({
        total_weekly_attendance: ''
    });

    const onChange = (size) => {
        setData("total_weekly_attendance", size);
    }

    const submit = (e) => {
        e.preventDefault();

        post(route('organization.add-attendance.store'));
    };

    return (
        <Authenticated className="extra-spacing" hideTopBar={true}>
            <Head title="Add Attendance"/>
            <div className="outside-logo"></div>
            <div className="add-attendance">
                <form onSubmit={submit}>
                    <div className="title" data-testid="add_attendance-div-title">
                        <div>{i18n.t("add-attendance.weekly-attendance-1")}</div>
                        <div>{i18n.t("add-attendance.weekly-attendance-2")}?</div>
                    </div>
                    <div className="row sizes" data-testid="add_attendance-div-attendance_options">
                        {attendanceOptions.map((option, key) => {
                            return (
                                <div key={key}
                                     data-testid={"add_attendance-div-attendance_options_" + option.replace(',','').replace('+', '_plus')}
                                     className={`col-12 col-sm-4 size ${option === data.total_weekly_attendance ? "selected" : ""}`}
                                     onClick={() => onChange(option)}>
                                    {option === "0-250" ? <img src={smallAttendanceIcon} alt="0-250"/> : null}
                                    {option === "250-1,000" ? <img src={mediumAttendanceIcon} alt="250-1,000"/> : null}
                                    {option === "1,000+" ? <img src={largeAttendanceIcon} alt="1,000+"/> : null}
                                    <span>{option}</span>
                                </div>
                            )
                        })}
                    </div>

                    <div className="">
                        <Button className="w-100 btn btn-primary" processing={processing || !data.total_weekly_attendance} dataTestid="add_attendance-button-continue">
                            <span>{i18n.t("add-attendance.continue")}</span><i className="far fa-chevron-right"></i>
                        </Button>
                    </div>
                </form>
            </div>
            <div className="step">
                <span>{i18n.t("add-attendance.step")} 3 {i18n.t("add-attendance.of")} 5</span>
            </div>
        </Authenticated>
    );
}
